"use strict";

exports.__esModule = true;
exports.getIllustrationProps = getIllustrationProps;

var _utils = require("@react-aria/utils");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getIllustrationProps(props) {
  let hasLabel = props['aria-label'] || props['aria-labelledby'];
  return _extends({}, (0, _utils.filterDOMProps)(props, {
    labelable: true
  }), {
    role: hasLabel ? 'img' : undefined,
    'aria-hidden': hasLabel ? undefined : true
  });
}